import React, { useState,memo } from 'react'
import { IProduto } from "../../../shared/services/api/permissoes/PermissoesService"
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@gvdasa/react-components'
import { SelectChangeEvent } from '@mui/material'

export interface ISelectDeProdutos {
  MenuProps: {}
  produtos: IProduto[]
  lista: string[]
  listaFiltrada: string[]
  
}

export const SelectDeProdutos: React.FC<ISelectDeProdutos> = memo(({
  MenuProps,
  produtos,
  lista,
  listaFiltrada
}) => {

  const listagem = produtos.map(produto => produto.nome);
  const [produtosSelecionados, setProdutosSelecionados] = useState<string[]>([]);

  const handleChange = (event: SelectChangeEvent<typeof produtosSelecionados>) => {
    const {
      target: { value },
    } = event;
    setProdutosSelecionados(
      typeof value === 'string' ? value.split(',') : value,
    );
  };


  const handleClick = (ev: any) => {
    if (ev.target.checked === true && !lista.includes(ev.target.value)) {
      lista.push(ev.target.value);
    }
    if (ev.target.checked === false) {
      const indice = lista.indexOf(ev.target.value);
      lista.splice(indice, 1);
    }
  };

  return (
    <div>
      <FormControl fullWidth>
        <InputLabel id="demo-multiple-checkbox-label">Produtos</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          size='medium'
          multiple
          value={listaFiltrada.length === 0 ? produtosSelecionados : listaFiltrada}
          onChange={handleChange}
          input={<OutlinedInput label="Produtos" />}
          renderValue={(selected) => (selected as string[]).join(', ')}
          MenuProps={MenuProps}
        >
          {listagem.map((produto, indice) => (
            <MenuItem key={indice} value={produto}>
              <Checkbox
                checked={listaFiltrada.length === 0 ? produtosSelecionados.indexOf(produto) > -1 : listaFiltrada.indexOf(produto) > -1}
                value={produto} onClick={handleClick} />
              <ListItemText primary={produto} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
})